module.exports = "<p>forgot-password works!</p>\n"